// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1ca5M","inputDescription":"styles_inputDescription__2fMXt"};